
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/offers/findOffers",
      function () {
        return require("private-next-pages/offers/findOffers.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/offers/findOffers"])
      });
    }
  